import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { useElementInteracted } from '@repo/platform-analytics/hooks/useElementInteracted';
import { useLinkClicked } from '@repo/platform-analytics/hooks/useLinkClicked';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { LinkViewed } from '@repo/platform-analytics/LinkViewed';
import { getOrCreateId } from '@repo/platform-utils/static-ids';
import { Button } from '@repo/ui/Button';
import { Link } from '@repo/ui/Link';
import { useRef } from 'react';
import type { BranchId } from '@/shared/config/funnel/constants';
import { ANALYTICS_ACTION_NAME, ANALYTICS_EXIT_INTENT_ACTION_SECTION } from './constants';
const EXIT_DESTINATION_URL = 'https://www.nerdwallet.com/credit-cards/best';
type CTAsProps = {
  parentActivityId: string;
  branchId: BranchId | null;
};
export function CTAs({
  parentActivityId,
  branchId
}: CTAsProps) {
  const fireExitPageActionAnalyticsEvent = usePageAction({
    actionName: ANALYTICS_ACTION_NAME,
    actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    actionType: 'select',
    actionInput: 'exit',
    parentActivityId,
    pageBranchName: branchId
  });
  const fireReturnPageActionAnalyticsEvent = usePageAction({
    actionName: ANALYTICS_ACTION_NAME,
    actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    actionType: 'select',
    actionInput: 'return',
    parentActivityId,
    pageBranchName: branchId
  });
  const additionalAttributes = branchId ? {
    page_branch_name: branchId
  } : undefined;
  const fireReturnElementInteracted = useElementInteracted({
    entityName: ANALYTICS_ACTION_NAME,
    sectionName: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    interactionType: 'click',
    itemCopy: 'return',
    parentEventId: parentActivityId,
    additionalAttributes
  });
  const linkViewedIdRef = useRef('');
  const linkViewedId = getOrCreateId(linkViewedIdRef);
  const fireExitLinkClicked = useLinkClicked({
    entityName: ANALYTICS_ACTION_NAME,
    sectionName: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    destinationUrl: EXIT_DESTINATION_URL,
    linkCopy: 'NO, THANKS',
    parentEventId: linkViewedId,
    additionalAttributes,
    immediate: true
  });
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: '3'
  })}>
      <Dialog.Close render={<Button onClick={() => {
      fireReturnPageActionAnalyticsEvent();
      fireReturnElementInteracted();
    }} className={css({
      height: '[45px]',
      fontSize: '14px'
    })}>
            KEEP GOING
          </Button>} />
      <LinkViewed entityName={ANALYTICS_ACTION_NAME} sectionName={ANALYTICS_EXIT_INTENT_ACTION_SECTION} destinationUrl={EXIT_DESTINATION_URL} linkCopy="NO, THANKS" eventId={linkViewedId} additionalAttributes={additionalAttributes}>
        <Link onClick={() => {
        fireExitPageActionAnalyticsEvent();
        fireExitLinkClicked();
      }} href={EXIT_DESTINATION_URL} underline="none" className={css({
        width: '[100%]',
        bg: 'common.white',
        border: '[1px solid]',
        borderColor: 'greens.main',
        height: '[45px]',
        fontSize: '14px',
        fontWeight: 'semibold',
        cursor: 'pointer',
        textStyle: 'body',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: '3',
        px: '3.5',
        _hover: {
          bg: 'neutral.lightest'
        }
      })} css={{
        color: 'greens.main'
      }}>
          NO, THANKS
        </Link>
      </LinkViewed>
    </div>;
}